 
export class MultipleChoiceSvarmulighed {
        public id: string;
        public multipleChoiceSpoergsmaalId: string;
        public svarmulighed: string;
        public isKorrekt: boolean;
        public order: number;
}   



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/models/MultipleChoiceSvarmulighed.ts